import React from "react";
import {
    withStyles,
    InputLabel,
    Input,
    FormControl,
    FormHelperText,
    InputAdornment,
    IconButton
} from "@material-ui/core";
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

const styles = (theme) => ({
    container: {
        display: "flex",
        flexWrap: "wrap",
    },
    cssLabel: {
        color: "#000!important",
        fontWeight: "bold",
        fontSize: "23px",
        "&$cssFocused:not($error)": {
            color: "#000!important",
            fontWeight: "bold",
            fontSize: "23px",
        },
    },
    cssFocused: {},
    cssUnderline: {
        "&:after": {
            borderBottomColor: "#b3b3b3",
        },
        "&:before": {
            borderBottomColor: "#b3b3b3",
        },
        "&:hover": {
            borderBottomColor: "#b3b3b3",
        },
        "&:hover:not($disabled):not($error):not($focused):before": {
            borderBottomColor: "#b3b3b3",
        },
    },
    disabled: {},
    error: {
        color: "#EE2737!important",
        borderBottomColor: "#EE2737!important",
    },
    focused: {},
});

class MaskedTextRipleyComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showPassword: false
        }
    }
    toggleMask = () => {
        this.setState({ showPassword: !this.state.showPassword });
    }
    render() {
        const { classes } = this.props;
        let txtId = this.props.id;
        let label;
        if (!txtId) {
            txtId = "txtInputText";
        }
        if (this.props.showLabel) {
            label = <InputLabel id="labelInputText" shrink formlabelclasses={{ root: classes.cssLabel, }} htmlFor={txtId}>{this.props.label}</InputLabel>
        }
        return (
            <FormControl id="inputText" fullWidth={this.props.fullWidth} >
                {label}
                < Input
                    classes={{
                        underline: classes.cssUnderline,
                    }}
                    id={txtId}
                    value={this.props.value}
                    onChange={this.props.onChange}
                    error={this.props.error}
                    onFocus={this.props.onFocus}
                    onBlur={this.props.onBlur}
                    autoComplete="off"
                    placeholder={this.props.placeholder}
                    disabled={this.props.disabled}
                    onPaste={this.props.onPaste}
                    type={this.state.showPassword ? 'text' : 'password'}
                    endAdornment={
                        <InputAdornment position="end" tabIndex="-1">
                            <IconButton
                                onClick={this.toggleMask}
                                onMouseDown={this.toggleMask}
                                tabIndex="-1"
                            >
                                {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton >
                        </InputAdornment>
                    }
                />
                <FormHelperText id="component-error-text" error={this.props.error}>
                    {this.props.errorText}
                </FormHelperText>
            </FormControl >

        );
    }
}

MaskedTextRipleyComponent.defaultProps = {
    showLabel: true
}
export default withStyles(styles)(MaskedTextRipleyComponent);
